(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["post-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.card-test').forEach((card) => {
    card.addEventListener('click', () => {
      card.classList.toggle('active');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
